// Self-hosted tutorial and demo videos (migrated from Vimeo).
// Files live in s3://assets.getsnug.com/files/videos/ — keys contain
// spaces and parens, so they must be URL-encoded.
const VIDEO_BASE_URL =
  "https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/videos";

const videoUrl = (filename: string): string =>
  `${VIDEO_BASE_URL}/${encodeURIComponent(filename)}`;

export const videos = {
  // Tutorials (/tutorials/:id)
  agentDashboardOnboarding: videoUrl("Agent Dashboard Onboarding Part 1.mp4"),
  clientPortalOnboarding: videoUrl("Client Portal Onboarding Part 2.mp4"),
  // Lives at the files/ root, not files/videos/.
  quitclaimDeedLaunch:
    "https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/quitclaim-deed-launch.mp4",

  // Overview / demo dialogs
  proDemoAccount: videoUrl("snug_-_pro_demo_account_v1 (1080p).mp4"),
  productDeepDive: videoUrl(
    "product_deep_dive_-_snug_estate_planning_platform_v1 (1080p).mp4"
  ),
  platformOverview: videoUrl("platform_overview_v1 (1080p).mp4"),

  // Upgrade flow
  howPricingWorks: videoUrl(
    "how_pricing_works_-_snug_estate_planning_platform_v1 (1080p).mp4"
  ),
  agentBranding: videoUrl("agent_branding_-_snug_estate_planning_v1 (1080p).mp4"),
  clientBranding: videoUrl(
    "client_branding_-_snug_estate_planning_v1 (1080p).mp4"
  ),
};

export const videoThumbnails = {
  agentDashboardOnboarding: `${VIDEO_BASE_URL}/thumbnails/agent_dashboard_onboarding_part_1.jpg`,
  clientPortalOnboarding: `${VIDEO_BASE_URL}/thumbnails/client_portal_onboarding_part_2.jpg`,
  quitclaimDeedLaunch: "/assets/courses/quitclaim-deed-launch.jpg",
};
